import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "What exactly is RideMate?",
    a: "RideMate is a pool-sharing app for India where anyone going the same direction — trip host or co-traveller — can ride together. Trip hosts post trips, co-travellers book seats, and both share the cost.",
  },
  {
    q: "How does the 10-minute role switch work?",
    a: "Your RideMate profile is dual-mode. Inside the app, a single toggle lets you switch from co-traveller to trip host (and back) within minutes — verification, pricing and trip posting are pre-loaded so you're live in under 10 minutes.",
  },
  {
    q: "When does the app launch?",
    a: "RideMate launches on 1 October 2026, rolling out city-by-city across India. Join the waitlist to be among the first to access RideMate when it goes live in your city.",
  },
  {
    q: "How does the ₹100 cashback work?",
    a: "The first 100 users on our waitlist automatically get ₹100 credited to their RideMate wallet on their first ride after launch. No coupon codes, no fine print.",
  },
  {
    q: "Is RideMate safe?",
    a: "Every trip host and co-traveller is ID-verified. We have in-app emergency support, two-way ratings, and round-the-clock human support.",
  },
  {
    q: "How much can I save / earn?",
    a: "Daily commuters typically save 50–60% versus solo cab rides. Hosts on a fixed daily route can offset most of their fuel and toll costs.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative pt-20 md:pt-24 pb-2 md:pb-4 border-t border-[#e5e7eb] bg-white"
    >
      <div className="mx-auto max-w-5xl px-6 lg:px-10">
        <div className="reveal">
          <span className="font-display text-[11px] uppercase tracking-[0.25em] text-[#5FA836] font-bold">
            FAQ
          </span>

          <h2 className="mt-4 font-display text-4xl md:text-6xl font-black tracking-[-0.03em] leading-tight text-[#24303F]">
            Questions, <span className="text-gray-400">answered.</span>
          </h2>
        </div>

        <Accordion
          type="single"
          collapsible
          className="mt-8 reveal"
          data-testid="faq-accordion"
        >
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className={`border-[#e5e7eb] ${
                i === faqs.length - 1 ? "border-b-0" : ""
              }`}
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="font-display text-lg md:text-xl font-semibold text-left text-[#24303F] hover:text-[#5FA836] hover:no-underline py-6">
                {f.q}
              </AccordionTrigger>

              <AccordionContent className="font-body text-gray-600 text-[15px] leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}